module.exports = __webpack_public_path__ + "assets/images/badge.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/badge.png
// module id = 1487
// module chunks = 1